var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button"},[_c('div',{staticClass:"success"},[_vm._v("绑定成功")]),_c('van-button',{attrs:{"color":"#EB5E00","size":"large"},on:{"click":_vm.submit}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }